import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';

export const BD_VIRTUAL_CLINIC_YEARS_CONDITION_ID = 'virtualClinicYears';

export const FilterConditionVirtualClinicYearsPluginType: FilterConditionPluginSpecification<
  number[],
  FilterConditionVirtualClinicYearsDto,
  BdVirtualClinicYearsCondition
> = {
  type: 'virtualClinicYears',
  category: 'case',
  displayName: { de: 'Entlass Jahr' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionVirtualClinicYearsDto,
  ): FilterConditionPluginImpl<number[]> {
    return new FilterConditionVirtualClinicYearsPlugin(obj.years);
  },
  fromCondition(
    jsonObj: BdVirtualClinicYearsCondition,
  ): FilterConditionPluginImpl<number[]> {
    return new FilterConditionVirtualClinicYearsPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<number[]> {
    return new FilterConditionVirtualClinicYearsPlugin([]);
  },
};

export class FilterConditionVirtualClinicYearsPlugin extends FilterConditionPluginImpl<
  number[],
  FilterConditionVirtualClinicYearsDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    number[],
    FilterConditionVirtualClinicYearsDto,
    BdVirtualClinicYearsCondition
  > = FilterConditionVirtualClinicYearsPluginType;

  constructor(private years: number[]) {
    super(FilterConditionVirtualClinicYearsPluginType.type);
  }

  clone(): FilterConditionVirtualClinicYearsPlugin {
    return new FilterConditionVirtualClinicYearsPlugin([...this.years]);
  }

  override equals(other: FilterConditionVirtualClinicYearsPlugin): boolean {
    return super.equals(other) && BdArrayUtil.equals(this.years, other.years);
  }

  override validationToText(): string {
    if (this.years.length === 0) {
      return 'Mindestens ein Entlass-Jahr auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdVirtualClinicYearsCondition(this.years);
  }

  toJSON(): FilterConditionVirtualClinicYearsDto | null {
    return {
      type: this.type,
      years: this.years,
    };
  }

  toText(): string | null {
    return 'Entlass-Jahr';
  }

  toValue(): number[] {
    return this.years;
  }
}

export class BdVirtualClinicYearsCondition extends BdContentCondition<number> {
  constructor(includes: number[] = [], excludes: number[] = []) {
    super(BD_VIRTUAL_CLINIC_YEARS_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionVirtualClinicYearsDto {
  type: string;
  years: number[];
}
